// src/pages/services/ScheduleRiskAnalysis.js
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ScheduleRiskAnalysis.module.css';

const ScheduleRiskAnalysis = () => {
  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <h1 className={styles.heroTitle}>Schedule Risk Analysis</h1>
        <p className={styles.heroText}>
          We ensure your project schedules are <strong>realistic, resilient, and defensible</strong> — backed by data-driven risk insight.
        </p>
        <Link to="/contact" className={styles.heroButton}>
          Book a Consultation
        </Link>
      </section>

      {/* Intro & Services Section */}
      <section className={styles.section}>
        <div className={styles.contentContainer}>
          <p className={styles.introText}>
            Nulek Consulting provides a comprehensive Schedule Risk Analysis (SRA) services to help organisations understand the uncertainty, risk exposure, and probability of achieving key project milestones. Our approach ensures that project schedules are not only technically sound but also tested for realism and resilience under a variety of risk conditions.
          </p>

          <h2 className={styles.sectionTitle}>Our Schedule Risk Analysis Services</h2>

          <ul className={styles.serviceList}>
            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Quantitative Schedule Risk Assessment (QSRA)</h3>
              <p className={styles.serviceDesc}>
                We perform detailed quantitative analysis using Monte Carlo simulation methods to identify the likelihood of meeting project dates and the range of possible outcomes. P-value confidence reporting (P20, P50, P80 dates), assessment of schedule realism and contingency requirements, identification of activities with the highest risk impact, probabilistic modelling of durations, sequencing and constraints.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Risk Identification & Mapping</h3>
              <p className={styles.serviceDesc}>
                We work closely with stakeholders to capture the risks that influence schedule performance. Workshops with project teams, designers, contractors, and owners, mapping of schedule risks to specific tasks and WBS elements, development of three-point estimates (optimistic, most likely, pessimistic), integration of risk drivers into the schedule model.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Schedule Sensitivity Analysis</h3>
              <p className={styles.serviceDesc}>
                We determine which risks and activities have the greatest influence on project timelines. Tornado diagrams and risk driver ranking, critical and near-critical chain analysis, identification of optimisation opportunities and mitigation pathways.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Scenario & Contingency Modelling</h3>
              <p className={styles.serviceDesc}>
                We provide insights into how different delivery options, phasing changes, or mitigation strategies affect the project outcome by performing "What-if" scenario testing, contingency and float allocation recommendations and assessment of acceleration and resequencing options.
              </p>
            </li>

            <li className={styles.serviceItem}>
              <h3 className={styles.serviceTitle}>Reporting & Executive Briefing</h3>
              <p className={styles.serviceDesc}>
                We deliver clear, defensible reports suitable for internal governance, financiers, and project boards. We provide summary dashboards and confidence curves, key risk drivers and recommended mitigations, comparison of deterministic vs probabilistic outcomes and strategic recommendations for schedule improvement.
              </p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default ScheduleRiskAnalysis;